import React, { useState, useEffect, useCallback } from 'react'
import { useModal } from 'react-modal-hook'
import { Formik, Form } from 'formik'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { REQUESTS_KEYS, DIALOG_KEYS, SIDENAV_KEYS, VALIDATION_MESSAGES } from '../../../../utils/translation-constants'
import { ChequeBookRequestSchema } from '../../../../schemas/requests'
import { carouselCurrentItemSelector, getFeatureListSelector } from '../../../../selectors'
import Modal from '../../../../components/Modal/Modal'
import RequestService from '../../../../services/requests.service'
import InputError from '../../../../components/InputError/InputError'
import NeoOTP from '../../../../components/FormComponents/NeoOTP'
import NeoSuccess from '../../../../components/FormComponents/NeoSuccess'
import NeoLoader from '../../../../components/FormComponents/NeoLoader'
import NeoButton from '../../../../components/NeoButton/NeoButton'
import NeoInput from '../../../../components/NeoInput/NeoInput'
import { useHistory } from 'react-router-dom'
import LayoutWithAccountCard from '../../../../layout/Layout/layout-account-card'
import BRANCH_DETAILS from './branch-details'
import AccountDisplay from '../../../../components/account-display/account-display'
import { values } from 'lodash'
import validationConfig from 'custom/config/validation.config.json'
const chequeBookConfig = validationConfig['OtherService']['chequeBook']

const chequeBookValues = [25, 50, 100]
const noOfChequeBooks = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
export default function ChequeBookRequest() {
  const { t } = useTranslation()
  const history = useHistory()
  const [stage, setStage] = useState(0)
  const [message, setMessage] = useState('')
  const currentAccountDetail = useSelector(carouselCurrentItemSelector)
  const [branches, setBranches] = useState([])
  const [verifyDetails, setVerifyDetails] = useState({})
  const [otp, setOtp] = useState('')
  const [loading, setLoading] = useState(false)
  const [loadingEligibility, setLoadingEligibility] = useState(false)
  const featureList = useSelector(getFeatureListSelector)
  const [formValues, setFormValues] = useState({
    accountNum: '',
    pickUpBranch: '',
    numberOfLeaves: '',
    numberOfBooks: '',
  })
  const [otpEnabled, setOtpEnabled] = useState(false)
  const featureDetails = featureList['CHEQUE_REQ']

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>
            <b>{message?.code}</b> : {message?.message}
          </h6>
          <div className='modal-btn-style'>
            <NeoButton
              mode='newDesign'
              type='button'
              text={t(DIALOG_KEYS.CLOSE)}
              onClick={() => {
                hideModal()
                // history.push('/requests')
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message],
  )
  useEffect(() => {
    fetchPreFormData()
  }, [])

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderForm()
      case 1:
        return renderConfirmation()
      case 3:
        return (
          <NeoOTP otp={otp} setOTP={setOtp} onSubmit={chequeBookFormRequest} loading={loading} />
        )
      case 4:
        return <NeoSuccess message={message} linkPath='/requests' />
      default:
        return <NeoLoader />
    }
  }

  const fetchPreFormData = useCallback(async () => {
    setLoading(true)
    try {
      const response = await RequestService.getPickUpBranches()
      if (response.status === 200) {
        setBranches(response.data['brnachList'])
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)
    }
  }, [])

  const checkAccountEligibility = useCallback(
    async (values) => {
      // const featureDetails = featureList['CHEQUE_REQ']
      // if (featureDetails[currentAccountDetail['accountType']] === 'N') {
      //   setMessage({
      //     code: t(DIALOG_KEYS.NO_ACCESS),
      //     message: t(DIALOG_KEYS.NO_ACCOUNTS),
      //   })
      //   showModal()
      //   return
      // }

      setLoading(true)
      setFormValues(values)
      try {
        const response = await RequestService.checkEligibility(currentAccountDetail?.accountNo)
        if (response.status !== 'OK') {
          setLoading(false)
          setMessage(response)
          showModal()
          return
        }
        await validateChequeBookFormRequest(values)
      } catch (err) {
        setLoading(false)
      }
    },
    [currentAccountDetail, featureList, branches],
  )

  const chequeBookFormRequest = useCallback(async () => {
    try {
      setLoading(true)
      const response = await RequestService.chequeBookRequest({
        accountNumber: currentAccountDetail?.accountNo,
        address: formValues.pickUpBranch,
        numberOfChequeBooks: formValues.numberOfBooks,
        numberOfLeaves: formValues.numberOfLeaves,
        customerNo: verifyDetails?.customerNo,
        accountName: verifyDetails?.accountName,
        pickupBranchCode: branches.find((v) => v.ADDRESS === formValues.pickUpBranch).BRANCH_CODE,
        otp: otp || '0000',
      })
      if (response.status === 200) {
        setMessage(response.data['message'])
        setLoading(false)
        setStage(4)
      }
    } catch (err) {
      setLoading(false)
      setOtp('')
    }
  }, [formValues, otp, branches, currentAccountDetail, verifyDetails])

  const validateChequeBookFormRequest = useCallback(
    async (formValues) => {
      try {
        setLoading(true)
        const response = await RequestService.validateChequeBookRequest({
          accountNumber: currentAccountDetail.accountNo,
          address: formValues.pickUpBranch,
          numberOfChequeBooks: formValues.numberOfBooks,
          numberOfLeaves: formValues.numberOfLeaves,
          pickupBranchCode: branches.find((v) => v.ADDRESS === formValues.pickUpBranch).BRANCH_CODE,
        })
        if (response.status === 200) {
          setVerifyDetails(response.data)
          setStage(1)
          setLoading(false)
          // if (response.data['otpEnable']) {
          //   setLoading(false)
          //   setStage(3)
          //   return
          // }
        }
      } catch (err) {
        setLoading(false)
      }
    },
    [branches, currentAccountDetail],
  )

  function renderConfirmation() {
    return (
      <div className='d-flex flex-column confirmation'>
        <h3>{t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_KEYS.SUBTITLE)}</h3>

        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <div>
          <h6 className='label'>{t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_KEYS.PICK_UP_BRANCH1)}</h6>
          <h6 className='value'>{formValues.pickUpBranch}</h6>
        </div>
        <div>
          <h6 className='label'>{t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_KEYS.NO_OF_LEAVES1)}</h6>
          <h6 className='value'>{formValues.numberOfLeaves}</h6>
        </div>

        <div>
          <h6 className='label'>{t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_KEYS.NO_OF_BOOKS)}</h6>
          <h6 className='value'>{formValues.numberOfBooks}</h6>
        </div>

        <div className='mt-3'>
          {loading ? (
            <NeoLoader />
          ) : (
            <NeoButton
              mode='newDesign'
              type='button'
              className='btn btn-neo'
              onClick={() =>
                verifyDetails?.otpEnable === true ? setStage(3) : chequeBookFormRequest()
              }
              text={t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_KEYS.CONFIRM)}
            />
          )}
        </div>
        <div className='back-cancel-style' onClick={() => setStage(0)}>
          {' '}
          {t(SIDENAV_KEYS.TOUCH_ID_KEYS.BACK)}
        </div>
      </div>
    )
  }

  function renderForm() {
    return (
      <div>
        <div className='heading-style'>{t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_KEYS.TITLE)}</div>
        <Formik
          initialValues={formValues}
          validationSchema={ChequeBookRequestSchema}
          onSubmit={checkAccountEligibility}>
          {({ isSubmitting, handleChange, errors, touched }) => (
            <Form>
              <AccountDisplay currentAccountDetail={currentAccountDetail} />
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex={'1'}
                    showAsterisk={chequeBookConfig['pickUpBranch']}
                    mode='select'
                    text={t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_KEYS.PICK_UP_BRANCH)}
                    name='pickUpBranch'
                    disabled={loadingEligibility}
                    onChange={handleChange}
                    list={branches}
                    keyValue='ADDRESS'
                    value={values.pickUpBranch}
                  />
                  <InputError text={errors.pickUpBranch} touched={touched.pickUpBranch} />
                </div>
              </div>
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex={'2'}
                    showAsterisk={chequeBookConfig['numberOfLeaves']}
                    mode='select'
                    text={t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_KEYS.NO_OF_LEAVES)}
                    name='numberOfLeaves'
                    disabled={loadingEligibility}
                    onChange={handleChange}
                    list={chequeBookValues}
                    keyValue={null}
                    value={values.numberOfLeaves}
                  />
                  <InputError text={errors.numberOfLeaves} touched={touched.numberOfLeaves} />
                </div>

                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex={'3'}
                    showAsterisk={chequeBookConfig['numberOfBooks']}
                    mode='select'
                    text={t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_KEYS.NO_OF_BOOKS)}
                    name='numberOfBooks'
                    disabled={loadingEligibility}
                    onChange={handleChange}
                    list={noOfChequeBooks}
                    keyValue={null}
                    value={values.numberOfBooks}
                  />
                  <InputError text={errors.numberOfBooks} touched={touched.numberOfBooks} />
                </div>
              </div>
              <div className='row'>
                <div className='form-group  col-12'>
                  {isSubmitting ? (
                    <NeoLoader />
                  ) : (
                    <NeoButton
                      tabIndex='4'
                      type='submit'
                      mode='newDesign'
                      disabled={loadingEligibility}
                      text={t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_KEYS.SUBMIT)}
                    />
                  )}
                </div>
              </div>
              <div className='back-cancel-btn-container'>
              <button className='back-cancel-btn btn btn-sm new-design-warning-text-color' tabIndex={'5'} onClick={() => history.goBack()}>
                {t(SIDENAV_KEYS.TOUCH_ID_KEYS.CANCEL)}
              </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  return (
    <LayoutWithAccountCard breadCumKey='REQUEST_CHEQUE_BOOK'>
      {featureDetails[currentAccountDetail['accountType']] !== 'N' && (
        <div className='new-design-form-style'>{renderSwitch()}</div>
      )}

      {featureDetails[currentAccountDetail['accountType']] === 'N' && (
        <div className='no-data-found'>{t(VALIDATION_MESSAGES.NO_ACCESS)}</div>
      )}
    </LayoutWithAccountCard>
  )
}
